import { Arrow3 } from "@monta/icons";
import { STATUS_CONFIG, DEFAULT_STATUS } from "../summary-info/status-config";

import type { FC } from "react";
import type { HeaderButtonProps } from "./types";

const HeaderButton: FC<HeaderButtonProps> = ({
  label,
  status = "نامشخص",
  active,
  onClick
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={!!active}
      className={
        "flex w-full items-center justify-between gap-3 rounded-xl border border-[#E2E8F0] bg-white px-4 py-3 text-right transition-colors hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 " +
        (active ? "!rounded-b-0 !border-b-0" : "")
      }
    >
      <span className="text-sm font-medium text-neutral-900">{label}</span>

      <span className="flex items-center gap-2" aria-hidden="true">
        <span
          className="w-[68px] border h-6 flex items-center justify-center rounded-3 text-[10px] font-medium"
          style={{
            color:
              STATUS_CONFIG[status ?? "نامشخص"]?.color || DEFAULT_STATUS.color,
            backgroundColor:
              STATUS_CONFIG[status ?? "نامشخص"]?.backgroundColor ||
              DEFAULT_STATUS.backgroundColor,
            borderColor:
              STATUS_CONFIG[status ?? "نامشخص"]?.color || DEFAULT_STATUS.color
          }}
        >
          {status ?? "نامشخص"}
        </span>

        <Arrow3
          className={
            "text-[#1D2939] transform transition-transform " +
            (active ? "rotate-0" : "rotate-180")
          }
          size={20}
        />
      </span>
    </button>
  );
};

export default HeaderButton;
